module.exports = __webpack_public_path__ + "img/dashboard2.33b328fb.png";